<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="dismiss()">
                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
            </ion-button>
        </ion-buttons>

        <ion-title mode="ios" role="heading" [innerHTML]="'CONTACT_HEADER' | translate"></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <div *ngIf="feedbackSubmitError">
        <ion-text *ngIf='formInvalid' color="danger" [innerHTML]="'CONTACT_ERROR_FORM' | translate "></ion-text>
        <ion-text *ngIf='invalidEmail' color="danger" [innerHTML]="'CONTACT_ERROR_EMAIL' | translate "></ion-text>
        <ion-text *ngIf='requestFailed' color="danger" [innerHTML]="'CONTACT_ERROR_REQUEST' | translate"></ion-text>
    </div>

    <ion-list>
        <p><span [innerHTML]="'CONTACT_EMAIL' | translate"></span>&nbsp;<ion-text color="danger">*</ion-text></p>
        <ion-item class="item-outline">
            <ion-input [(ngModel)]="email" type="text" clearInput></ion-input>
        </ion-item>

        <!--
            if we have an access code, just include it with the request and don't ask for it here.
            could be confusing with multiple codes and particularly if entering with a generic code
        -->
        <p *ngIf="showAccessCode === true"><span [innerHTML]="'CONTACT_ACCESS_CODE' | translate"></span><br/>
        <!-- <span class="subtext">If you've lost your survey invitation access code, please provide your mailing address in your message.</span> -->
        </p>

        <ion-item *ngIf="showAccessCode === true" class="item-outline">
            <ion-input [(ngModel)]="accessCode" type="text" clearInput></ion-input>
        </ion-item>


        <p><span [innerHTML]="'CONTACT_NAME' | translate"></span>&nbsp;<ion-text color="danger">*</ion-text></p>
        <ion-item class="item-outline">
            <ion-input [(ngModel)]="name" type="text" clearInput></ion-input>
        </ion-item>


        <p><span [innerHTML]="'CONTACT_FEEDBACK' | translate"></span>&nbsp;<ion-text color="danger">*</ion-text></p>
        <ion-item class='item-textarea item-outline'>
            <ion-textarea rows="3" [(ngModel)]="feedback"></ion-textarea>
        </ion-item>

        <p class="ion-text-center subtext">
            <span [innerHTML]="'CONTACT_REQURED' | translate"></span>
            <ion-text color="danger">*</ion-text>
        </p>
    </ion-list>

    <ion-button
        expand="block"
        class="emphasized-button"
        (click)="submit()"
        [innerHTML]="'CONTACT_BUTTON_SUBMIT' | translate"></ion-button>

</ion-content>
